<template>
    <div>
        <div class="portfolio-map">
            <div class="portfolio-map-left">
                <img width="221" height="141" class="img-responsive" src="images/Our-Work-Page/map.png" alt="USA map">
            </div>
            <div class="portfolio-map-right">
                <p class="basic-paragraph">
                    FROM COMMUNITY PROJECTS
                    <br class="break-sm"/>
                    TO MAJOR SPORTS TEAMS,
                    <br/>
                    WE HAVE A PROJECT IN YOUR AREA!
                </p>
                <div class="portfolio-map-numbers">
                    <img width="493" height="28" class="img-responsive" src="images/Our-Work-Page/mapnumbers.png" alt="">
                </div>
            </div>
        </div>
        <div class="portfolio-map-numbers-sm">
            <img width="493" height="28" class="img-responsive" src="images/Our-Work-Page/mapnumbers.png" alt="">
        </div>

        <hr class="frl-hr"/>

        <ul class="client-list">
            <li>
                <router-link tag="a" to="/community-projects">
                    <img src="images/Our-Work-Page/portfoliohome01.png" alt="COMMUNITY PROJECTS">
                </router-link>
            </li>
            <li>
                <router-link tag="a" to="/k12-schools">
                    <img src="images/Our-Work-Page/portfoliohome02.png" alt="K-12 SCHOOLS">
                </router-link>
            </li>
            <li>
                <router-link tag="a" to="/parks">
                    <img src="images/Our-Work-Page/portfoliohome03.png" alt="PARKS">
                </router-link>
            </li>
            <li>
                <router-link tag="a" to="/churches">
                    <img src="images/Our-Work-Page/portfoliohome04.png" alt="CHURCHES">
                </router-link>
            </li>
            <li>
                <router-link tag="a" to="/military">
                    <img src="images/Our-Work-Page/portfoliohome05.png" alt="MILITARY">
                </router-link>
            </li>
            <li>
                <a href="http://fundraiserssports.com/projects-sports.html" target="_blank">
                    <img src="images/Our-Work-Page/portfoliohome06.png" alt="PROFESSIONAL SPORTS">
                </a>
            </li>
            <li>
                <a href="http://fundraiserssports.com/projects-university.html" target="_blank">
                    <img src="images/Our-Work-Page/portfoliohome07.png" alt="UNIVERSITIES/COLLEGES">
                </a>
            </li>
            <li>
                <router-link tag="a" to="/client-list">
                    <img src="images/Our-Work-Page/portfoliohome08.png" alt="CLIENT LIST">
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'our-work',
        metaInfo: {
            title: 'Our Work',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'In our 30+ years our projects have been featured across the U.S., Canada and Mexico, including stadiums, venues, schools, churches, parks, military venues, etc.'
                }
            ]
        }
    }
</script>



// WEBPACK FOOTER //
// OurWork.vue?544ae8a8